import Cookies from 'js-cookie';

const cookieWarning = () => {
    if (!Cookies.get('cookieWarning')) {
        const cookieWarningDiv = document.createElement('div');
        cookieWarningDiv.className = 'cookie-warning';
        cookieWarningDiv.innerHTML = `
            <div>
                На сайте используются файлы cookies, а также Яндекс.Метрика. Продолжая использовать сайт вы даете согласие на работу с этими данными.<br>
                Подробнее: <a href="/soglasie/" target="_blank" rel="nofollow">Согласие на обработку персональных данных</a>, <a href="/politika/" target="_blank" rel="nofollow">Политика конфиденциальности</a>.
            </div>
            <button class="button cookie-warning__btn">Хорошо</button>
        `;

        document.body.appendChild(cookieWarningDiv);

        document.querySelector('.cookie-warning__btn').addEventListener('click', (e) => {
            e.preventDefault();
            cookieWarningDiv.style.display = 'none';

            try {
                Cookies.set('cookieWarning', 'true', { expires: 365 });
            } catch (error) {
                console.error('Error setting cookie on cookieWarning:', error);
            }
        });
    }
};

export default cookieWarning;
